<div class="container" >   
        <div class="parentClass" [innerHTML]="html" *ngIf="data !== null && data !== undefined"></div>   
    
     <div class="noContent" *ngIf="data === null || data === undefined"><p>No content found</p> </div>
    <div class="loader" [hidden]="showLoader">
        <i class="fa fa-spinner fa-spin"></i>
      </div> 
</div>
